import React, { FC } from "react";
import type { EcosystemHeroProps } from "@/types";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const EcosystemHero: FC<EcosystemHeroProps> = ({
  label,
  title,
  description,
  cover,
}) => {
  return (
    <section className="ecosystemHero">
      <div className="wrapper">
        <TextCols
          headingLevel="h1"
          size="lg"
          label={label}
          content={{
            title,
            textCol1: description,
          }}
          singleCol
          maxTitleWidth={883}
        />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            loading="eager"
            fetchPriority="high"
            className="ecosystemHero--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
